export default "__VITE_ASSET__C2$rX6v6__"